import useReduxAction from '@hooks/useReduxAction'

const BackOffice = (props) => {
  const { children } = props

  useReduxAction('emailReplacements', 'loadEmailReplacements', {})
  useReduxAction('serviceCategories', 'loadServiceCategories', {})
  useReduxAction('wordReplacements', 'loadWordReplacements', {})
  useReduxAction('zones', 'loadZones', {})

  useReduxAction('employmentTypesV3', 'loadEmploymentTypesV3', {})
  useReduxAction('userFlagsV3', 'loadUserFlagsV3', {})
  useReduxAction('userRolesV3', 'loadUserRolesV3', {})
  useReduxAction('providerFlagsV3', 'loadProviderFlagsV3', {})
  useReduxAction('serviceTypesV3', 'loadServiceTypesV3', {})
  useReduxAction('statesV3', 'loadStatesV3', {})
  useReduxAction('zonesV3', 'loadZonesV3', {})

  return children
}

export default BackOffice
